<template>
  <div>
    <div class="gradient-bg"></div>
    <div class="LOHeader">
      <hr1 style="font-size: 3.8rem">Find a Loan Officer near you!</hr1>
    </div>

    <div class="gold-lor" style="margin-top: 30px;">
      <div class="gold-line"></div>
    </div>

    <div class="search-container">
      <kendo-text-box class="search-box" v-model="searchQuery" placeholder="Search for a Loan Officer..." />
    </div>

    <div class="flipper">
      <div v-for="(officer, index) in filteredOfficers" :key="index" class="officer">
        <card class="officerCard"
          style="width: 305px; border-radius: 5%; height: 370px; background-color: transparent; border-color: #4a6ded; border-width: 2px; margin-bottom: 20px">
          <a role="button" @click="sendToLO(officer.lar)">
            <cardBody>
              <span v-if="officer.lo_image == 'https://consumer-portal-public-bucket.s3.amazonaws.com/default.svg'">
                <cardImage style="height: 100px; border-radius: 50%;"
                  src="https://banner2.cleanpng.com/20180404/sqe/avhxkafxo.webp">
                </cardImage>
              </span>
              <span v-else>
                <cardImage style="height: 100px; border-radius: 50%;" :src="officer.lo_image">
                </cardImage>
              </span>
              <div class="gold-line4" style="margin-bottom: 20px; margin-top: 15px; width: 90px; margin-left: 5px;">
              </div>
              <cardTitle style="font-size: 1.8rem; color: black; margin-top: 40px;">
                {{ officer.first_name }} {{ officer.last_name }}
              </cardTitle>
              <p style="font-size: large; margin-top: 20px;">{{ officer.phone_number }}</p>
              <p style="font-size: small; margin-top: 20px;">{{ officer.email }}</p>
            </cardBody>
          </a>
        </card>
      </div>
    </div>

    <FooterComp></FooterComp>
  </div>
</template>


<script>
import FooterComp from "../components/Footer_Comp.vue"
import apiService from '../api/api.service';
import { Card, CardBody, CardImage, CardTitle } from "@progress/kendo-vue-layout";
import { TextBox } from "@progress/kendo-vue-inputs"; // Import Kendo TextBox

export default {
  components: {
    FooterComp,
    card: Card,
    cardBody: CardBody,
    cardImage: CardImage,
    cardTitle: CardTitle,
    kendoTextBox: TextBox,
  },

  name: "LoanOfficers",

  data() {
    return {
      searchQuery: "",
      orgid: new URLSearchParams(window.location.search).get('org') || 'MILI01',
      BranchPage: {},
      Officers: [],
      isLoading: false,
    };
  },

  computed: {
    uniqueOfficers() {
      const seen = new Set();
      return this.Officers.filter(officer => {
        const isDuplicate = seen.has(officer.first_name + officer.last_name);
        seen.add(officer.first_name + officer.last_name);
        return !isDuplicate;
      });
    },

    filteredOfficers() {
      if (!this.searchQuery) {
        return this.uniqueOfficers;
      }

      return this.uniqueOfficers.filter(officer =>
        (`${officer.first_name} ${officer.last_name}`)
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase())
      );
    }
  },

  mounted() {
    this.GetBranchPage();
    this.GetOfficers();
  },

  methods: {
    GetBranchPage() {
      return apiService.GetBranchPage(this.orgid)
        .then(res => {
          this.BranchPage = res.data.data[0];
          this.isLoading = false;
        })
        .catch(error => {
          this.isLoading = false;
          console.error(error);
        });
    },

    GetOfficers() {
      this.isLoading = true;
      return apiService.GetLOInfoByOrgID(this.orgid)
        .then(res => {
          this.Officers = res.data.data;
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    sendToLO(lar) {
      window.location.href = ("https://lo-sites.goldstarfinancial.com/?lar=" + lar);
    }
  }
};
</script>


<style>
.officer {
  justify-content: center;
  align-items: center;
  margin-top: 100px;
}

.search-box{
  border-color: black;
}

.search-container {
  margin-top: 30px;
  justify-self: center;
  width: 80vw;
  max-width: 300px;
}

.flipper {
  justify-content: center;
  padding-bottom: 100px;
  position: relative;
  left: 53%;
  transform: translateX(-50%);
  display: inline-grid;
  grid-template-rows: auto;
  grid-template-columns: repeat(4, 450px);
}

.LOHeader {
  text-align: center;
  width: 100%;
  margin-top: 40px;
}

@media (max-width: 1600px) {
  .flipper {
    left: 55%;
    grid-template-columns: repeat(3, 450px);
  }
}

@media (max-width: 430px) {
  .LOHeader {
    margin-top: 100px;
  }

  .flipper {
    left: 50%;
    display: block;
  }

  .officerCard {
    margin-left: auto;
    margin-right: auto;
  }
}
</style>